import './Leadership.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';

import boardBg from '../../assets/img/doctors/doctor-01.jpg';
// import bhavik from './dr bhavik (1).jpg';
// import mahesh from './dr. mahesh rathore.JPG';
// import sangeeta from './sangeeta.JPG';
import founder from "./DOC.jpg"
import dr2 from '../../assets/img/doctors/doctor-05.jpg';
import dr3 from '../../assets/img/doctors/doctor-06.jpg';
import hitakrilogo from '../../assets/img/hitakrilogo.png';
import Footer from '../Footer/Footer';
import AchievementsSection from '../AchievementsSection/AchievementsSection';


const Leadership = () => {
    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

          

            <div className="leadership-banner" style={{ backgroundImage: `url(${boardBg})` }}>
                <div className="container">
                    <h1>Board of Directors</h1>
                    <p>Balotra-based Hitkari Hospital provides all major medical and surgical services 24 hours. The Center is equipped with state-of-the-art laboratory and medical equipment and a 50-bed Hospital.</p>
                    <div className="leadership-buttons">
                        <a href="/appointments" className="appointment-button">Appointment</a>
                        <a href="/contact" className="contact-button">Contact Us</a>
                    </div>
                </div>
            </div>

            <div className="leadership-content">
                <div className="container">

                    {/* First Profile - Large Image */}
                    <div className="leader-profile first-profile">
                        <div className="leader-image">
                            <img src={founder} alt="Premlata Choudhary" />
                        </div>
                        <div className="leader-details">
                            <h3>Premlata Choudhary</h3>
                            <span className="leader-title">Founder</span>
                            <p className="leader-quote">Welcome to Hitkari Hospital BALOTRA, where compassion meets excellence in healthcare.<br/>
As the owner and founding member of this multi-speciality institution, it has been my
mission to create a space where patients are treated not just for their ailments, but with
dignity, respect, and personalized care. Our vision is rooted in delivering world-class medical
services through cutting-edge technology, highly skilled professionals, and a patient-first
approach.<br/>
At Hitkari Hospital, we believe that healing goes beyond treatment it requires trust,
transparency, and a deep human connection. That’s why we’ve assembled a team of experts
across specialties, all united by a single goal: your well-being.<br/>
Thank you for placing your trust in us. We are honored to be your partners in health.
Warm regards,<br/><br/>
Premlata Choudhary<br/>
Founding Member<br/>
Hitkari Hospital &amp; Surgical center Balotra</p>
                        </div>
                    </div>

                

                   

                 

                </div>
            </div>
           <AchievementsSection/>
        </div>
      <Footer/>
        </>
    );
};

export default Leadership;